export default __webpack_public_path__ + "static/media/tickets.7b90c9aa.svg";